import {useSyncExternalStore} from 'react';

import {isNil} from 'ramda';

import {pricedItemGroupStore} from '../utils/pricedItemGroupStore';

/**
 * The open group of the model year, or `undefined`. Without a model year (the library page mounts
 * the features tab without one) there is no group.
 */
export function usePricedItemGroup(modelYearId?: string) {
  const getGroup = () => (isNil(modelYearId) ? undefined : pricedItemGroupStore.get(modelYearId));
  return useSyncExternalStore(pricedItemGroupStore.subscribe, getGroup, getGroup);
}
